import styled from "styled-components";
import { COLORS } from "../../../const/colors";

export const SkillsContainer = styled.section`
  padding: 6rem 0 2rem;
  background-color: ${(props) => (props.light ? COLORS.WHITE : COLORS.BLACK)};
  transition: background-color 0.4s;
  position: relative;
  z-index: 1;
`;

export const SkillsContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 350px);
  column-gap: 3rem;
  justify-content: center;

  @media screen and (max-width: 992px) {
    grid-template-columns: max-content;
    row-gap: 2rem;
  }

  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const SkillsBox = styled.div`
  .skills__title {
    font-size: var(--h3-font-size);
    font-weight: var(--font-medium);
    color: ${(props) => (props.light ? COLORS.BLACK : COLORS.WHITE)};
    text-align: center;
    margin-bottom: var(--mb-1-5);
  }
`;

export const SkillsGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const SkillsData = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  position: relative;
  z-index: 1;

  &:hover {
    z-index: 100;
  }
`;

export const SkillsName = styled.h3`
  font-size: var(--normal-font-size);
  font-weight: var(--font-medium);
  color: ${(props) => (props.light ? COLORS.BLACK : COLORS.WHITE)};
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SkillsIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  color: ${COLORS.ORANGE};

  i {
    font-size: 0.875rem;
  }
`;

export const SkillsLevel = styled.span`
  font-size: var(--smaller-font-size);
  color: ${(props) => (props.light ? COLORS.BLACK_70 : COLORS.WHITE_70)};
`;

export const SkillsBar = styled.div`
  background-color: ${(props) =>
    props.light ? COLORS.BLACK_10 : COLORS.WHITE_10};
  height: 5px;
  border-radius: 0.25rem;
`;

export const SkillsPercentage = styled.span`
  height: 5px;
  border-radius: 0.25rem;
  background: linear-gradient(90deg, ${COLORS.ORANGE}, ${COLORS.DARK_BLUE});
  width: ${(props) => props.width || "0%"};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
`;

export const SkillsIcon = styled.div`
  position: absolute;
  right: -0.5rem;
  top: -0.75rem;
  font-size: 1rem;
  color: ${COLORS.ORANGE};
  transition: transform 0.3s;

  ${SkillsData}:hover & {
    transform: scale(1.2);
  }
`;

export const SkillSection = styled.section`
  padding: 6rem 0 3rem;
  background: linear-gradient(to bottom, ${COLORS.ORANGE_30}, transparent);
  position: relative;
  overflow: visible;
  z-index: 1;

  &::after {
    content: "";
    position: absolute;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      ${COLORS.ORANGE_30} 0%,
      rgba(255, 255, 255, 0) 70%
    );
    top: 10%;
    z-index: 0;
  }

  @media screen and (min-width: 992px) {
    padding: 7rem 0 3rem;
  }
`;

export const SkillContainer = styled.div`
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 1.5rem;
  padding-top: 2rem;

  @media screen and (min-width: 992px) {
    padding-top: 3rem;
  }
`;

export const SkillContent = styled.div`
  background-color: ${(props) =>
    props.light ? COLORS.DARK_BLUE_80 : COLORS.WHITE_80};
  padding: 2rem 1.5rem;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid ${COLORS.ORANGE_10};

  @media screen and (min-width: 576px) {
    padding: 2.5rem 3rem;
  }
`;

// export const SkillTitle = styled.h3`
//   font-size: 0.938rem;
//   font-weight: 600;
//   text-align: center;
//   margin-bottom: 1.5rem;
//   color: hsla(0, 100%, 45%, 1);
// `;

export const SkillBox = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const SkillGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 1.5rem;
  width: 100%;

  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 2rem;
  }
`;

export const SkillData = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background-color: ${(props) =>
    props.light ? COLORS.DARK_BLUE_30 : COLORS.WHITE_80};
  border-radius: 1rem;
  padding: 1rem 1.25rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: visible;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 1rem;
    padding: 1px;
    background: linear-gradient(
      90deg,
      ${COLORS.ORANGE_60},
      ${COLORS.ORANGE_10},
      ${COLORS.ORANGE_60},
      ${COLORS.ORANGE_10}
    );
    background-size: 300% 100%;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  @keyframes animatedBorder {
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: 300% 0%;
    }
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);

    &::before {
      animation: animatedBorder 4s linear infinite;
    }
  }

  i {
    font-size: 1.25rem;
    color: ${COLORS.ORANGE};
    background: linear-gradient(45deg, ${COLORS.ORANGE}, ${COLORS.DARK_BLUE});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media screen and (max-width: 320px) {
    padding: 0.75rem 1rem;
  }
`;

export const SkillName = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: ${(props) => (props.light ? COLORS.WHITE : COLORS.BLACK)};
  margin-bottom: 0.25rem;

  @media screen and (max-width: 320px) {
    font-size: 0.875rem;
  }
`;

export const SkillLevel = styled.span`
  font-size: 0.75rem;
  color: ${(props) => (props.light ? COLORS.WHITE_70 : COLORS.ORANGE_80)};
  display: inline-block;
  padding: 0.1rem 0.5rem;
  border-radius: 0.5rem;
  background: ${(props) => (props.light ? COLORS.WHITE_10 : COLORS.ORANGE_10)};

  @media screen and (max-width: 320px) {
    font-size: 0.7rem;
  }
`;

export const SkillWrapper = styled.div`
  position: relative;
  cursor: pointer;

  &:hover {
    z-index: 99999;
  }
`;

export const RelationIndicator = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${COLORS.ORANGE};
  border: 2px solid
    ${(props) => (props.light ? COLORS.DARK_BLUE : COLORS.WHITE)};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 2;
`;

export const InfoIcon = styled.i`
  font-size: 0.9rem;
  margin-left: auto;
  opacity: 0.7;
  color: ${(props) => (props.light ? COLORS.WHITE_80 : COLORS.ORANGE_80)};
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }
`;
